import { Button, useTranslation } from '@hbs-us/ui';
import { Link } from '@tanstack/react-router';
import { BarChart3 } from 'lucide-react';

/**
 * Empty-state card (legacy ReportsPage 114–132): shown when the period has no
 * report data at all. The legacy page linked to Jobs / Timesheets / Invoices to
 * seed data; on the new platform those rooms are not yet built (D-02), so the
 * single primary CTA routes to the Invoices room (its ComingSoon placeholder).
 * The decorative icon replaces the legacy 📊 emoji with the brand chart glyph.
 */
export function ReportsEmptyState() {
  const { t } = useTranslation();
  return (
    <div className="rounded-md border border-border bg-card p-12">
      <div className="flex flex-col items-center gap-4 text-center">
        <BarChart3 className="size-10 text-muted-foreground" aria-hidden="true" />
        <h2 className="font-display font-semibold text-foreground text-xl">
          {t('reports:empty.heading')}
        </h2>
        <p className="max-w-md text-muted-foreground text-sm">{t('reports:empty.body')}</p>
        <Button asChild>
          <Link to="/invoices">{t('reports:empty.cta')}</Link>
        </Button>
      </div>
    </div>
  );
}
